import React from "react";
import { useHeaderTitle } from "../../../context/HeaderTitleContext";
import DestinationTabs from "./DestinationTabs";

const Invities = () => {
  
console.log('inside invite 2')
  const { resetHeaderTitle } = useHeaderTitle();
  React.useEffect(() => {
    resetHeaderTitle();
  }, []);
  return (
    <>
      <DestinationTabs />
    </>
  );
};

export default Invities;
